import { useEffect, useState } from 'react';
import userInfo, { userInfoSync } from 'hub-http/userInfo';
export const useUserInfo = () => {
  const [userInfoResponse, setUserInfoResponse] = useState(() => {
    // initialize with userInfoSync in case userInfo has already been loaded.
    // this avoids an initial render without gates/scopes, if possible.
    // userInfoSync throws an Error if userInfo has not finished loading yet;
    // in that case fall back to waiting for async userInfo
    try {
      return userInfoSync();
    } catch (__error) {
      return undefined;
    }
  });
  useEffect(() => {
    if (userInfoResponse) {
      return;
    }

    // ignoreRedirect is important! Without it, any consumers of GPC that don't
    // support or shim userInfo can end up redirecting (the default behavior).
    // This has caused past critsits:
    // https://git.hubteam.com/HubSpot/Critsit/issues/3557
    // https://git.hubteam.com/HubSpot/Critsit/issues/1040
    void userInfo({
      ignoreRedirect: true
    }).then(response => {
      setUserInfoResponse(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return userInfoResponse;
};